var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "dealt-content" },
        [
          _c(
            "div",
            { staticClass: "mb15" },
            [
              _c(
                "el-button",
                { staticClass: "add-task", on: { click: _vm.addTask } },
                [
                  _c("i", { staticClass: "el-icon-plus" }),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("calendar.addtask")) +
                      "\n        "
                  ),
                  _c("i", { staticClass: "el-icon-bell icon-task-dell" }),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.dayArray.length > 0
            ? _c(
                "div",
                [
                  _c(
                    "ul",
                    { staticClass: "task-list" },
                    _vm._l(_vm.dayArray, function (item) {
                      return _c(
                        "li",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: item.finish === 0,
                              expression: "item.finish === 0",
                            },
                          ],
                          key: item.id,
                          on: {
                            click: function ($event) {
                              return _vm.handleItemClick(item)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "task-list-left" }, [
                            _c("i", {
                              staticClass: "pointer",
                              class:
                                item.finish === 1
                                  ? "el-icon-success"
                                  : "el-icon-garden",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.setScheduleRecord(item)
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "task-list-right" }, [
                            _c("p", [_vm._v(_vm._s(item.content))]),
                            _vm._v(" "),
                            _c("p", [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("customer.reminderdata")) + ":"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(item.remind_day) +
                                    " " +
                                    _vm._s(item.remind_time)
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "task-text" }, [
                    _c(
                      "span",
                      {
                        staticClass: "pointer",
                        on: { click: _vm.addCompleteTask },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.complete === true ? "隐藏" : "显示") +
                            "已完成事项\n          "
                        ),
                        _c("i", {
                          class:
                            _vm.complete === true
                              ? "el-icon-arrow-up"
                              : "el-icon-arrow-down",
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("el-collapse-transition", [
                    _c(
                      "ul",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.complete,
                            expression: "complete",
                          },
                        ],
                        staticClass: "task-list",
                      },
                      _vm._l(_vm.dayArray, function (item) {
                        return _c(
                          "li",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: item.finish === 1,
                                expression: "item.finish === 1",
                              },
                            ],
                            key: item.id,
                            on: {
                              click: function ($event) {
                                return _vm.handleItemClick(item)
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "task-list-left" }, [
                              _c("i", {
                                class:
                                  item.finish === 1
                                    ? "el-icon-success"
                                    : "el-icon-garden",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.setScheduleRecord(item)
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "task-list-right" }, [
                              _c("p", [_vm._v(_vm._s(item.content))]),
                              _vm._v(" "),
                              _c("p", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("customer.reminderdata")) +
                                      ":"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(item.remind_day) +
                                      " " +
                                      _vm._s(item.remind_time)
                                  ),
                                ]),
                              ]),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                ],
                1
              )
            : _c("default-page", {
                directives: [{ name: "height", rawName: "v-height" }],
                attrs: { "min-height": 510, index: 8 },
              }),
        ],
        1
      ),
      _vm._v(" "),
      _c("dialog-form", {
        ref: "dialogForm",
        attrs: { "form-data": _vm.formBoxConfig },
        on: { isOk: _vm.handleList },
      }),
      _vm._v(" "),
      _c("check-dialog", {
        ref: "repeatDialog",
        attrs: { "repeat-data": _vm.repeatData },
        on: { handleRepeatData: _vm.handleRepeatData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }